import { render, staticRenderFns } from "./Gamburger.vue?vue&type=template&id=519bea22&scoped=true&"
import script from "./Gamburger.vue?vue&type=script&lang=js&"
export * from "./Gamburger.vue?vue&type=script&lang=js&"
import style0 from "./Gamburger.vue?vue&type=style&index=0&id=519bea22&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "519bea22",
  null
  
)

export default component.exports